import { useState } from 'react';
import * as CryptoJS from 'crypto-js';

interface UseLocalStorageInterface {
  key: string;
  initialValue?: object;
}
interface UseLocalStorageReturnInterface {
  storedValue: { [x: string]: string | undefined } | object;
  setStoreValue: Function;
}

interface ValueInterface {
  [x: string]: string | object | undefined;
}

const useLocalStorage = ({
  key,
  initialValue,
}: UseLocalStorageInterface): UseLocalStorageReturnInterface => {
  const secretKey = process.env.REACT_APP_SECRET_ENCRYPTION_KEY
    ? process.env.REACT_APP_SECRET_ENCRYPTION_KEY
    : 'secretKeyTestHook';

  const encrypted = (value: string): string =>
    CryptoJS.AES.encrypt(value, secretKey).toString();

  const decrypted = (encrypted: string): string =>
    CryptoJS.AES.decrypt(encrypted, secretKey).toString(CryptoJS.enc.Utf8);

  const [storedValue, setStoredValue] = useState(() => {
    const item = window.localStorage.getItem(key);
    let value = undefined;
    try {
      value = item ? JSON.parse(decrypted(item)) : initialValue;
    } catch (e) {
      localStorage.removeItem(key);
    }
    return value;
  });

  const setStoreValue = (value: ValueInterface): void => {
    const valueToStore = encrypted(JSON.stringify(value));
    setStoredValue(valueToStore);
    window.localStorage.setItem(key, valueToStore);
  };

  return { storedValue, setStoreValue };
};

export default useLocalStorage;
